<template>
  <div class="load-more-container">
    <el-pagination
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
      size="default"
      :background="false"
      :hide-on-single-page="true"
      layout="prev, pager, next"
      @update:current-page="updatePage"
    />
  </div>
</template>

<script setup lang="ts">
import { ElPagination } from 'element-plus'

interface Props {
  currentPage: number
  pageSize: number
  total: number
}

defineProps<Props>()

const emit = defineEmits<{
  'update:currentPage': [value: number]
}>()

function updatePage(val: number) {
  emit('update:currentPage', val)
}
</script>

<style scoped>
.load-more-container {
  display: flex;
  justify-content: center;
}
</style>

